import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonGroup,
  Button,
  Modal,
} from 'react-bootstrap';
import BidDetail from './BidDetail';
import HotelFeedbackLink from './HotelFeedbackLink';

class BidDetailModal extends React.Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    //this.props.requestBidDetails(this.props.bid.id)
  }
  render() {

    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              Hotel Bid Detail: {this.props.bid.hotel.name}
              ({this.props.bid.bidset.event.group_name})</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <BidDetail
              bid={this.props.bid}
              bids={this.props.bids}
              isHide={this.props.showSend}
              editBid={this.props.editBid}
              addBidNote={this.props.addBidNote}
              sendBid={this.props.sendBid}
              sendHotelBidRequests={this.props.sendHotelBidRequests}
              removeBid={this.props.removeBid}
              isTourManager={this.props.isTourManager}
              readOnly={this.props.readOnly}
              user={this.props.user}
              tourData={this.props.tourData}
              editMember={this.props.editMember}
              bidbidsDetails={this.props.bidbidsDetails}
              isLoading={this.props.isLoading}
              answers={this.props.answers}
              editGroup={this.props.editGroup}
              ChangeBidDetail={this.props.ChangeBidDetail}
              changeBidDateDetail={this.props.changeBidDateDetail}
              editGroupEventOnManageBid={this.props.editGroupEventOnManageBid}
              requestBidDetails={this.props.requestBidDetails}
              dispatchRemoveMemberFromManageBid={this.props.dispatchRemoveMemberFromManageBid}
              changeDateRoomType={this.props.changeDateRoomType}
              addParticipantManageBid={this.props.addParticipantManageBid}
            />
          </Modal.Body>
          <Modal.Footer >
            <HotelFeedbackLink id={this.props.bid.hotel.id} />
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}


BidDetailModal.propTypes = {
  bid: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  editBid: PropTypes.func.isRequired,
  addBidNote: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  removeBid: PropTypes.func.isRequired,
  isTourManager: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  tourData: PropTypes.object,
  editMember: PropTypes.func,
};

BidDetailModal.defaultProps = {
  proposal: {
    contacts: [],
    bids: [],
  },
};
export default BidDetailModal;



// WEBPACK FOOTER //
// src/routes/tours/components/BidDetailModal.js